@if (!externalLink()) {
  <a
    [routerLink]="'/' + link()"
    class="navigation-link transition-all group flex flex-row p-2 items-center no-underline"
    [class.navigation-link--collapsed]="isCollapsed()"
    [class.navigation-link--expanded]="!isCollapsed()"
    [class.active]="!noActiveHighlight() && (rla.isActive || isAlsoActive())"
    [attr.aria-label]="displayName()"
    [attr.title]="isCollapsed() ? displayName() : null"
    routerLinkActive
    #rla="routerLinkActive"
    [routerLinkActiveOptions]="{ exact: exactMatch() }"
  >
    <div
      class="navigation-link__icon flex-initial flex flex-row items-center text-white transition-all"
      [class.ml-3]="!isCollapsed()"
    >
      <mat-icon [svgIcon]="icon()" class="icon" />
    </div>
    @if (__.IsNullOrUndefinedOrEmpty(tag()) && isCollapsed() === false) {
      <div class="display-name text-lg flex-auto text-white no-underline ml-5 transition-all">
        {{ displayName() }}
      </div>
    }
    @if (!__.IsNullOrUndefinedOrEmpty(tag()) && isCollapsed() === false) {
      <div class="display-name text-lg flex-auto text-white no-underline ml-5 transition-all">
        {{ displayName() }}
        <sup>{{ tag() }}</sup>
      </div>
    }
  </a>
}

@if (externalLink()) {
  <a
    [href]="link()"
    class="navigation-link transition-all group flex flex-row p-2 items-center no-underline"
    [class.navigation-link--collapsed]="isCollapsed()"
    [class.navigation-link--expanded]="!isCollapsed()"
    [attr.aria-label]="displayName()"
    [attr.title]="isCollapsed() ? displayName() : null"
    rel="noopener noreferrer"
    routerLinkActive="active"
    target="_blank"
  >
    <div
      class="navigation-link__icon flex-initial flex flex-row items-center text-white transition-all"
      [class.ml-3]="!isCollapsed()"
    >
      <mat-icon [svgIcon]="icon()" class="icon" />
    </div>
    @if (isCollapsed() === false) {
      <div class="display-name display-name--external text-lg flex-auto text-white no-underline ml-5 transition-all">
        <span class="display-name__text">
          {{ displayName() }}
        </span>
        <mat-icon aria-hidden="true" class="navigation-link__external-icon">open_in_new</mat-icon>
      </div>
    }
  </a>
}
